// extracted by mini-css-extract-plugin
export default {"select":"select-ZzJGjW","selectText":"selectText-XCzab_","popover":"popover-fHbIzJ","popoverItem":"popoverItem-LFdKPz","menu":"menu-Nw7SPk"};